// auth.service.ts
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ILocalidades } from '../../models/ILocalidades';

@Injectable({
	providedIn: 'root'
})
export class GetLocalidadesService {
	private http = inject(HttpClient);

	constructor() {}

	getLocalidadesOrigen(): Observable<ILocalidades[]> {
		return this.http.get<ILocalidades[]>(`${environment.apiEcommercebUrl}/Maestro/localidad`);
	}
	getLocalidadesDestino(idOrigen: any): Observable<ILocalidades[]> {
		return this.http.get<ILocalidades[]>(`${environment.apiEcommercebUrl}/Maestro/localidad/destino/${idOrigen}`);
	}
}
